// Batch downloads (FR-24): one ZIP with every result. jszip is loaded only
// when a batch is downloaded.

export type NamedBlob = { name: string; blob: Blob };

/** "photo.jpg" twice → "photo.jpg", "photo (2).jpg". */
export function uniqueNames(names: string[]): string[] {
  const seen = new Map<string, number>();
  return names.map((name) => {
    const key = name.toLowerCase();
    const n = (seen.get(key) ?? 0) + 1;
    seen.set(key, n);
    if (n === 1) return name;
    const dot = name.lastIndexOf(".");
    return dot > 0
      ? `${name.slice(0, dot)} (${n})${name.slice(dot)}`
      : `${name} (${n})`;
  });
}

export async function zipFiles(files: NamedBlob[]): Promise<Blob> {
  const { default: JSZip } = await import("jszip");
  const zip = new JSZip();
  const names = uniqueNames(files.map((f) => f.name));
  // Images are already compressed, so "STORE" is fast and barely bigger.
  files.forEach((f, i) => zip.file(names[i], f.blob, { compression: "STORE" }));
  return zip.generateAsync({ type: "blob", mimeType: "application/zip" });
}
